// Shared constants for the Brand SKU Mapper MFR->DP review view and its sub-components.

// Which side of the mapping a product panel renders.
export const SIDE = { MANUFACTURER: 'manufacturer', VENDOR: 'vendor' };
